// extracted by mini-css-extract-plugin
export default {"homeButton":"KingsGuard_homeButton__yx5MJ","mapButton":"KingsGuard_mapButton__5kIeN","button":"KingsGuard_button__xgiqv"};